import 'firebase/app';
import 'firebase/analytics';
import FirebaseManager from './firebaseManager.js';

const CryptoJS = require('crypto-js');

export default class EventManager {
  constructor() {
    this.firebase = FirebaseManager.getInstance();
  }

  setUserProperties({ uniqueId, deviceModel, isFree, groupId, role, version, buildNumber }) {
    this.firebase.analytics().setUserId("" + uniqueId);
    this.firebase.analytics().setUserProperties(
      this.stringifyValue({
        membership: isFree ? "Plus/Free" : "Premium",
        device_model: deviceModel,
        group_id: "" + groupId,
        xmpp_type: "alfred_xmpp",
        role,
        version,
        build_number: buildNumber
      })
    );
  }

  clearUserProperties() {
    this.firebase.analytics().setUserId(null);
    this.firebase.analytics().setUserProperties(
      this.stringifyValue({
        membership: null,
        group_id: null
      })
    );
  }

  signInPageLanded(productVersion) {
    const obj = this.stringifyValue({
      sign_in_page_version: productVersion,
    });
    this.firebase.analytics().logEvent("grt_signinup_landed", obj);
  }

  signInPageClickItem({ item }) {
    const obj = this.stringifyValue({
      item,
    });
    this.firebase.analytics().logEvent("grt_signinup_clicked", obj);
  }

  signInEmailPageLanded() {
    const obj = this.stringifyValue({
      entry: "signin",
    });
    this.firebase.analytics().logEvent("grt_signinemail_landed", obj);
  }

  signInEmailPageClick({ item }) {
    const obj = this.stringifyValue({
      item,
      status: "1",
    });
    this.firebase.analytics().logEvent("grt_signinemail_clicked", obj);
  }

  verifyPageLanded() {
    const obj = this.stringifyValue({
      entry: "signin",
    });
    this.firebase.analytics().logEvent("grt_verification_landed", obj);
  }

  verifyPageClick() {
    const obj = this.stringifyValue({
      item: "signin",
      status: "1",
    });
    this.firebase.analytics().logEvent("grt_verification_clicked", obj);
  }

  sendInitialLoginSucceeded({ provider, email, type = "quick" }) {
    const obj = this.stringifyValue({
      provider,
      type,
      ivuu: CryptoJS.MD5(email).toString(),
    });
    this.firebase.analytics().logEvent("initial_login_succeeded", obj);
  }

  logingTime({ provider, btnclickLogin }) {
    const obj = this.stringifyValue({
      provider,
      btnclick_login: btnclickLogin,
    });
    this.firebase.analytics().logEvent("grt_login_time", obj);
  }

  sendLoginFailed({ provider, type = "quick", code = null, customError }) {
    const obj = this.stringifyValue({
      provider,
      type,
      code: "" + code,
      custom_error: customError,
    });
    this.firebase.analytics().logEvent("initial_login_failed", obj);
  }

  stringifyValue(obj) {
    let data = JSON.parse(JSON.stringify(obj));
    Object.keys(data).forEach((key) => {
      if (Number.isInteger(data[key])) {
        data[key] = String(data[key]);
      }
    });
    return data;
  }
}